import script from "./ContractDataConfirmations.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractDataConfirmations.vue?vue&type=script&setup=true&lang=js"

import "./ContractDataConfirmations.vue?vue&type=style&index=0&id=1ac31dbc&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./ContractDataConfirmations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac31dbc"]])

export default __exports__